<!--
  "Add Camera" control: validates alphanumeric camera name (no duplicates) and emits
  add-new. Naming rules match ImportMultiCamDialog/multicamSubfolderLayout isValidCameraName.
-->
<script lang="ts">
import {
  defineComponent, PropType, computed, ref,
} from 'vue';

export default defineComponent({
  name: 'ImportMultiCamAddType',
  props: {
    nameList: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const newSetName = ref('');
    const alphaNumeric = /^[a-zA-Z0-9_]*$/;
    const enabled = ref(false);

    const addNewSet = () => {
      emit('add-new', newSetName.value);
      newSetName.value = '';
      enabled.value = false;
    };
    const nameRules = computed(() => [
      (v: string) => !!v || 'Name is required',
      (v: string) => alphaNumeric.test(v) || 'Letters, numbers, and underscores only',
      (v: string) => !v.includes(' ') || 'No spaces',
      (v: string) => !props.nameList.includes(v) || 'No duplicate Names',
    ]);
    return {
      enabled,
      newSetName,
      nameRules,
      addNewSet,
    };
  },
});
</script>

<template>
  <v-row
    class="align-start"
    no-gutters
    style="height: 48px;"
  >
    <v-btn
      color="primary"
      class="mr-3"
      :disabled="enabled"
      @click="enabled = true"
    >
      Add Camera
      <v-icon class="ml-1">
        mdi-camera
      </v-icon>
    </v-btn>
    <template v-if="enabled">
      <v-text-field
        v-model="newSetName"
        :rules="nameRules"
        label="name"
        placeholder="Choose a Camera Name"
        outlined
        persistent-hint
        dense
        hide-details="auto"
      />
      <v-btn
        color="error"
        class="mx-3"
        @click="newSetName = ''; enabled = false;"
      >
        Cancel
      </v-btn>
      <v-btn
        color="success"
        @click="addNewSet"
      >
        Create
      </v-btn>
    </template>
  </v-row>
</template>
